module.exports = __webpack_public_path__ + "static/dowBG-7c0044574f63720eebbc5896d51ddd5c.jpg";